import React, { Component, Fragment } from 'react';
import styles from './ContentDisplay.module.css';
import Grid from '../Grid';
import PropTypes from 'prop-types';
import ReactSelect from 'react-select';
import Divider from '../Divider';
import TableView from '../TableView';
import moment from 'moment';

export default class ContentDisplay extends Component {
  state = {
    headers: {
      models: [
        'Product Name',
        'Collection Code',
        'Item Type Code',
        'Season Code',
        'Version',
        'Status',
      ],
      materials: [
        'Material Name',
        'Tags',
        'Choice Code',
        'Season Code',
        'Lighting',
        'Status',
      ],
      scenes: ['Scene Name', 'Last Updated At'],
    },
    sortBy: { index: 0, order: 1 },
  };

  static contextTypes = {
    router: PropTypes.object,
  };

  filterByTags = select => {
    const { onChange } = this.props;
    onChange('tag', select && select.value);
  };

  viewModel = id => {
    const { router } = this.context;
    const { catogary } = this.props;
    router.history.push(`/${catogary}/${id}`);
  };

  changeDisplayType = () => {
    const { displayType, onChange } = this.props;
    const newDisplayType = displayType === 'list' ? 'carousel' : 'list';
    onChange('displayType', newDisplayType);
  };

  filterModelByTag = item => {
    const { tagValue } = this.state;
    if (!tagValue) return true;
    return item.tags.indexOf(tagValue) !== -1;
  };

  formatModelData = (items, catogary) => {
    let content = [];
    if (catogary === 'models') {
      content = Object.keys(items)
        .filter(key => this.filterModelByTag(items[key]))
        .map(k => [
          { label: items[k].friendlyName, value: items[k]._id },
          items[k]['metadata']['Collection Code'],
          items[k]['metadata']['Item Code'],
          items[k]['metadata']['Season'],
          items[k]['version'],
          items[k]['pipeline'],
        ]);
    } else if (catogary === 'materials') {
      content = Object.keys(items)
        .filter(key => this.filterModelByTag(items[key]))
        .map(k => [
          { label: items[k].friendlyName, value: items[k]._id },
          items[k].tags.join(','),
          items[k]['metadata']['Material Code'],
          items[k]['metadata']['Season'],
          items[k]['metadata']['Lighting'],
          items[k]['pipeline'],
        ]);
    } else if (catogary === 'scenes') {
      content = Object.keys(items).map(k => [
        { label: items[k].friendlyName, value: items[k]._id },
        moment(items[k].updatedAt).fromNow(),
      ]);
    }

    const { sortBy } = this.state;
    if (sortBy) {
      content.sort((a, b) => {
        if (typeof a[sortBy.index] === 'object') {
          return sortBy.order > 0
            ? a[sortBy.index]['label'] > b[sortBy.index]['label']
              ? 1
              : -1
            : a[sortBy.index]['label'] < b[sortBy.index]['label']
            ? 1
            : -1;
        }
        return sortBy.order > 0
          ? a[sortBy.index] > b[sortBy.index]
            ? 1
            : -1
          : a[sortBy.index] < b[sortBy.index]
          ? 1
          : -1;
      });
    }
    return content;
  };

  onPageEnd = page => {
    const { onPageLeave, filterAlphabet, tag } = this.props;
    const query = { page: page + 1 };
    if (tag) {
      query.tags = tag;
    }
    if (filterAlphabet) {
      query.friendlyName = filterAlphabet;
      query.page = page + 1;
    }
    onPageLeave(query);
  };

  fetchAlphabetModel = query => {
    const { onPageLeave, tag } = this.props;
    if (tag) query.tags = tag;
    onPageLeave(query);
  };

  onHeaderClick = k => {
    const { sortBy } = this.state;
    if (sortBy.index === k) {
      sortBy.order *= -1;
    } else {
      sortBy.index = k;
      sortBy.order = 1;
    }
    this.setState({ sortBy });
  };

  setLetterFilter = e => {
    this.fetchAlphabetModel({
      page: 0,
      friendlyName: e.target.id,
    });
    const { onChange } = this.props;
    onChange('filterAlphabet', e.target.id);
  };

  filterAlphabet = items => {
    const { filterAlphabet, entitystate, tag } = this.props;
    for (let i in items) {
      if (filterAlphabet) {
        if (items[i].friendlyName[0].toUpperCase() !== filterAlphabet) {
          delete items[i];
          continue;
        }
      }
      if (items[i].state !== entitystate) {
        delete items[i];
        continue;
      }
      if (tag && items[i].tags.indexOf(tag) === -1) {
        delete items[i];
      }
    }
    return items;
  };

  filterByState = async data => {
    if (!data) return;
    const { onChange } = this.props;
    onChange('entitystate', data.value);
  };

  renderCatogery = cat => {
    const {
      navTo,
      tags,
      onSelect,
      products,
      selected,
      createJob,
      filterAlphabet,
      tag,
      displayType,
      entitystate,
    } = this.props;
    const { headers } = this.state;
    let items = this.filterAlphabet(this.props[cat]);
    const content = this.formatModelData(items, cat);
    const collectionOptions =
      products &&
      Object.keys(products).map(item => ({
        label: products[item].name,
        value: products[item].name.toLowerCase(),
      }));
    collectionOptions.sort((a, b) =>
      a.value.replace(/\s|\n/g, '') > b.value.replace(/\s|\n/g, '') ? 1 : -1
    );
    const alphabetArr = Array.from({ length: 26 }, (_, i) =>
      String.fromCharCode('A'.charCodeAt(0) + i)
    );
    return (
      <div key={cat} className={styles.catContainer}>
        <div className={styles.catHeader}>
          {cat[0].toUpperCase() + cat.substr(1)}
          <div className={styles.tagContainer}>
            <img
              src={`/img/${displayType}.png`}
              className={styles.displayType}
              onClick={this.changeDisplayType}
            />
            {cat === 'models' && (
              <Fragment>
                <div className={styles.tagLabel}> Collection </div>
                <ReactSelect
                  className={styles.tagDropdown}
                  onChange={this.filterByTags}
                  placeholder="All"
                  value={tag}
                  options={collectionOptions}
                />
              </Fragment>
            )}
            {cat === 'materials' && (
              <Fragment>
                <div className={styles.tagLabel}>Tags </div>
                <ReactSelect
                  className={styles.tagDropdownLong}
                  onChange={this.filterByTags}
                  placeholder="All"
                  value={tag}
                  options={tags.map(v => v[0])}
                />
                <div className={styles.tagLabel}>State </div>
                <ReactSelect
                  className={styles.tagDropdown}
                  onChange={this.filterByState}
                  placeholder={entitystate}
                  value={entitystate}
                  options={[
                    { label: 'Active', value: 'Active' },
                    { label: 'Discontinued', value: 'Discontinued' },
                  ]}
                />
              </Fragment>
            )}
          </div>
        </div>
        <Divider />
        <div className={styles.alphabetContainer}>
          {alphabetArr.map(v => (
            <div
              className={styles.singeAlphabet}
              key={v}
              style={{
                borderBottom: filterAlphabet === v ? '3px solid #000' : '',
              }}
              id={v}
              onClick={this.setLetterFilter}
            >
              {v}
            </div>
          ))}
          <img
            id={null}
            className={styles.singeAlphabet}
            onClick={this.setLetterFilter}
            width="20"
            height="20"
            src="/img/close.png"
          />
        </div>
        {displayType === 'list' ? (
          <Grid
            createJob={createJob}
            tag={tag}
            items={items}
            navTo={navTo}
            catogary={cat}
            onSelect={onSelect}
            selected={selected}
            onLeave={this.onPageEnd}
          />
        ) : (
          <TableView
            headers={headers[cat]}
            data={content}
            onClick={this.viewModel}
            rowColor="#2375C2"
            onSelect={onSelect}
            selected={selected}
            onHeaderClick={this.onHeaderClick}
            onLeave={this.onPageEnd}
            fetchAplphabet={this.fetchAlphabetModel}
          />
        )}
      </div>
    );
  };

  render() {
    const { catogary } = this.props;
    return (
      <div className={styles.container}>
        {catogary.map(t => this.renderCatogery(t))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ContentDisplay/index.js